import LocalizationList from './LocalizationList';

export default {
  list: LocalizationList,
};
